"use client";

import React from "react";

//Type
import { SelectProps } from "@/types";
//Styled
import * as S from "./styles";

//Components
import LabelInput from "@/components/label";
import Icon from "@/components/icon";

const Select: React.FC<
  SelectProps & React.SelectHTMLAttributes<HTMLSelectElement>
> = ({ className, label, placeholder, options, name, onChange, ...rest }) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <>
      {label && <LabelInput labelInput={label} />}
      <S.BoxSelect
        className={className}
        disabled={rest?.disabled ? true : false}
      >
        <S.SelectComponent
          name={name}
          onChange={handleChange}
          {...rest}
          autoComplete="off"
        >
          {placeholder && (
            <S.OptionSelect value="" disabled selected hidden>
              {placeholder}
            </S.OptionSelect>
          )}
          {options.map((option) => (
            <S.OptionSelect key={option.value} value={option.value}>
              {option.label}
            </S.OptionSelect>
          ))}
        </S.SelectComponent>
        <S.IconComponent name="chevronDown" />
      </S.BoxSelect>
    </>
  );
};

export default Select;
